import { render, staticRenderFns } from "./DisciplineandAttendance.vue?vue&type=template&id=a5c630c0&scoped=true&"
import script from "./DisciplineandAttendance.vue?vue&type=script&lang=ts&"
export * from "./DisciplineandAttendance.vue?vue&type=script&lang=ts&"
import style0 from "./DisciplineandAttendance.vue?vue&type=style&index=0&id=a5c630c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5c630c0",
  null
  
)

export default component.exports